const PreventNavigationUrls = {
    urlArray: [
        "/withdrawal/advisory",
        "/withdrawal/nonrothallocations",
        "/withdrawal/rothallocations",
        "/withdrawal/beneficiary",
        "/withdrawal/accumulation",
        "/distribution/types",
        "/distribution/reasons",
        "/distribution/amount",
        "/distribution/citizenship-verification",
        "/distribution/review",
        "/distribution/employment-check",
        "/loan/reasons",
        "/loan/quotes",
        "loan/loanRepayment",
        "/loan/updates",
        "/loan/requestSummary",
        "/loan/principalResidenceReqDoc",
        "/rmd/request",
        "/rmd/citizenship-verification",
        "/loan/loanPromissoryNote"
    ]
};

export default PreventNavigationUrls;
